"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let AsyncCommand = class AsyncCommand extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getPoller(...args) {
        if (!this._poller) {
            this._poller = new this.$app.helpers.AsyncCommandPoller(this.$app, this.handleError.bind(this), (data) => this.$emit('completed', data));
        }
        return this._poller;
    }
    beforeDestroy(...args) {
        {
            {
                this.poller && this.poller.stop();
            }
        }
    }
    submit(...args) {
        const [event] = args;
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
        if (this.poller.isRunning) {
            return false;
        }
        this.poller.begin(Promise
            .resolve(_.isFunction(this.payload) ? this.payload() : this.payload)
            .then(payload => {
            if (!payload || payload.cancel) {
                return;
            }
            return this.$app.connections
                .request(this.operation, { content: payload })
                .then(resp => resp.data);
        }));
    }
    icon;
    onIcon(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("icon");
    }
    text;
    onText(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("text");
    }
    operation;
    onOperation(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("operation");
    }
    payload;
    onPayload(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payload");
    }
    dropdownItem;
    onDropdown_item(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("dropdownItem");
    }
    block;
    onBlock(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("block");
    }
    variant;
    onVariant(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("variant");
    }
    disabled;
    onDisabled(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("disabled");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tooltip;
    onTooltip(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("tooltip");
    }
    pollingInterval;
    onPolling_interval(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("pollingInterval");
    }
    type;
    onType(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("type");
    }
    form;
    onForm(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("form");
    }
    poller;
    async $$load_poller() {
        return this.getPoller();
    }
    ux;
    dataMembers = ['poller', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                poller: null,
                ux: null,
            },
        };
    }
    async act_7315092382398562_script_4272_getActionArgs_value($event) {
        this.submit($event);
    }
    async act_7315092382398562_script_4272_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_4272_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_4272 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_4272_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_clickPreventStop_4271 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_4272,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_4271],
        });
        return {
            act_7315092382398562_script_4272,
            evh_7315092382398562_clickPreventStop_4271,
            evh_7315092382398562_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "icon", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('icon'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onIcon", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('text'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onText", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "operation", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('operation'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onOperation", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
    }),
    __metadata("design:type", typeof (_a = typeof Function !== "undefined" && Function) === "function" ? _a : Object)
], AsyncCommand.prototype, "payload", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onPayload", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], AsyncCommand.prototype, "dropdownItem", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dropdownItem'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onDropdown_item", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], AsyncCommand.prototype, "block", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('block'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onBlock", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('variant'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onVariant", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], AsyncCommand.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onDisabled", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onSize", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "tooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('tooltip'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onTooltip", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Number,
        default: 1000,
    }),
    __metadata("design:type", Number)
], AsyncCommand.prototype, "pollingInterval", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('pollingInterval'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onPolling_interval", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], AsyncCommand.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('type'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onType", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({}),
    __metadata("design:type", Object)
], AsyncCommand.prototype, "form", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('form'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AsyncCommand.prototype, "onForm", null);
AsyncCommand = __decorate([
    (0, vue_property_decorator_1.Component)()
], AsyncCommand);
exports.default = AsyncCommand;
vue_property_decorator_1.Vue.component("AsyncCommand", AsyncCommand);
